import axios from 'axios'
import { transbankAppis } from './appisUrlConfig'

const appisTransbank = axios.create({
  baseURL: transbankAppis
})

export default appisTransbank
